export const CommentOrderType = {
  LATEST: 'LATEST',
  OLDEST: 'OLDEST',
  POPULAR: 'POPULAR',
};

export const commentOrderTypes = [
  CommentOrderType.LATEST,
  CommentOrderType.OLDEST,
  CommentOrderType.POPULAR,
];
